import React from "react";
import { useNavigate } from "react-router-dom";

function PaymentFailed() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f4f0ec",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "700px",
          background: "#fff",
          borderRadius: "30px",
          padding: "60px 40px",
          textAlign: "center",
          border: "1px solid #eaded8",
        }}
      >
        <div
          style={{
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: "#dc2626",
            margin: "0 auto 30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "60px",
            fontWeight: "700",
          }}
        >
          ✕
        </div>

        <h1
          style={{
            color: "#5a140c",
            fontSize: "56px",
            marginBottom: "15px",
            fontWeight: "800",
          }}
        >
          Payment Failed
        </h1>

        <p
          style={{
            color: "#666",
            lineHeight: "36px",
            fontSize: "18px",
            marginBottom: "40px",
          }}
        >
          Your payment could not be completed. Please retry the payment process.
        </p>

        <div
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
          }}
        >
          <button
            onClick={() => navigate(-1)}
            style={{
              height: "56px",
              padding: "0 35px",
              border: "none",
              borderRadius: "12px",
              background: "#5a140c",
              color: "#fff",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Retry Payment
          </button>

          <button
            onClick={() => navigate("/")}
            style={{
              height: "56px",
              padding: "0 35px",
              border: "1px solid #ddd",
              borderRadius: "12px",
              background: "#fff",
              color: "#5a140c",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Go To Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentFailed;
